import base from './base'
import goods from './pmc/goods'
import designer from './pmc/designer'
import webCase from './cms/case'
import tips from './cms/tips'
import wy from './cms/wy'
import address from './member/address'
import project from './member/project'
import order from './member/order'
import member from './member/member'

export default {
    base,
    goods,
    address,
    order,
    member,
    designer,
    webCase,
    tips,
    project,
    wy
}


// WEBPACK FOOTER //
// ./src/request/index.js